import React from 'react';
import { useTranslation } from 'react-i18next';

export enum AvailabilityLevel {
	NONE = 'none',
	LOW = 'low'
}

type TableInventoryNoticeProps = {
	level: AvailabilityLevel;
};

export const TableInventoryNotice: React.FC<TableInventoryNoticeProps> = ({ level }) => {
	const { t } = useTranslation();
	if (level === AvailabilityLevel.NONE) {
		return (
			<div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
				<p className="text-red-800 text-sm">
					{t('messages.no_tables_available', { defaultValue: 'No tables available for the selected time. Try selecting a different time or date.' })}
				</p>
			</div>
		);
	}

	if (level === AvailabilityLevel.LOW) {
		return (
			<div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
				<p className="text-yellow-800 text-sm">
					{t('messages.limited_availability', { defaultValue: 'Limited availability remaining for this time slot.' })}
				</p>
			</div>
		);
	}

	return null;
};